/**
 * 系统全局配置
 */
import qs from 'qs'
import { getCookie } from '../util/cookie-util'
import { LOCAL_ENV } from '../../local.config'
import { isApp } from '../util/common-util'

let ENV = getCookie('ENV')
//兼容移动端
if (isApp) {
    if (window.location.host === 'uathr-outside.guazi-cloud.com') {
        ENV = 'uat'
    } else if (window.location.host === 'testhr-outside.guazi-cloud.com') {
        ENV = 'test'
    } else if (window.location.host === 'devhr-outside.guazi-cloud.com') {
        ENV = 'dev'
    } else if (window.location.host === 'testhr-outside.dev.aitongqian.com') {
        ENV = 'testqf'
    } else if (window.location.host === 'hr-outside.app.aitongqian.com' || window.location.host === 'hr-outside.aitongqian.com') {
        ENV = 'qf'
    } else {
        ENV = 'online'
    }
    // ENV = 'test'
}
const ENV_FLAG = ENV || LOCAL_ENV

const baseConfig = {
    dev: {
        appKey: 'dev',
    },
    test: {
        appKey: 'test',
    },
    testqf: {
        appKey: 'testqf',
    },
    uat: {
        appKey: 'uat',
    },
    online: {
        appKey: 'online',
    },
    qf: {
        appKey: 'qf',
    },
}
const serverConfig = {
    base: {
        'dev': '//deveimapi.guazi-cloud.com/eim-platbase',
        'test': '//testeimapi.guazi-cloud.com/eim-platbase',
        'testqf': '//testeimapi.dev.aitongqian.com/eim-platbase',
        'uat': '//uateimapi.guazi-cloud.com/eim-platbase',
        'online': '//eimapi.guazi.com/eim-platbase',
        'qf': '//eimapi.aitongqian.com/eim-platbase',
    },
    plat: {
        'dev': '//deveimapi.guazi-cloud.com',
        'test': '//testeimapi.guazi-cloud.com',
        'testqf': '//testeimapi.dev.aitongqian.com',
        'uat': '//uateimapi.guazi-cloud.com',
        'online': '//eimapi.guazi.com',
        'qf': '//eimapi.aitongqian.com',
    },
}
function configGenerate(platName, config = {}) {
    return {
        baseURL: serverConfig[platName] ? serverConfig[platName][ENV_FLAG] : '',
        withCredentials: (config.withCredentials === false || config.withCredentials === true) ? config.withCredentials : !isApp,
        timeout: config.timeout || 10000,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        paramsSerializer: config.paramsSerializer || (params => qs.stringify(params, { arrayFormat: 'brackets' })),
    }
}
export const config = configGenerate('base')
export const platConfig = configGenerate('plat')
export const appKey = baseConfig[ENV_FLAG].appKey
